module.exports = __webpack_public_path__ + "img/loca_classic.838d3b5e.png";